
interface TitleTextProps {
  text?: string;
}

export default function TitleText({ text }: TitleTextProps) {
  return (
    <div className="text-[20px] text-[1C1C1C] w-full text-left font-[700] mb-[15px]">{text}</div>
  );
}

